import { render, staticRenderFns } from "./Corte.vue?vue&type=template&id=2b8dc613&"
import script from "./Corte.vue?vue&type=script&lang=js&"
export * from "./Corte.vue?vue&type=script&lang=js&"
import style0 from "./Corte.vue?vue&type=style&index=0&id=2b8dc613&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports